import React, { useEffect, useState } from "react";
import moment from "moment";
import { IoClose } from "react-icons/io5";
import { FcImageFile } from "react-icons/fc";
import { toast } from "react-toastify";
import { FaEye } from "react-icons/fa";
import MainPageDialog from "../../../components/dialog";
import { usePrepareDataMutation } from "../../../services/shareDataService";
import FullScreenLoader from "../../../components/FullScreenLoader";

function OrderRequestData(props) {
  const {
    setOpenOrderRequestDialog,
    openOrderRequestDialog,
    shareDataArr,
    resetHandler,
    selectedChat,
    isLocationTab,
  } = props;
  const [processShareDataArr, setProcessShareDataArr] = useState();
  const [prepareData, { isLoading: prepareDataLoading }] =
    usePrepareDataMutation();

  const {
    practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  useEffect(() => {
    let finalArr = [];
    let order = 1;
    if (!isLocationTab) {
      Object?.keys(shareDataArr)?.map((shareDataKey, index) => {
        let shareDataObj = shareDataArr[shareDataKey];
        if (shareDataKey == "clinicalRecord") {
          let selectedCR = shareDataObj?.data?.filter((v, k) => v?.checked);
          selectedCR?.map((v, k) => {
            let obj = { ...shareDataObj, ...v, key: shareDataKey, order };
            if (v?.slug == "patient_sheet") {
              obj.csv = shareDataArr?.csv && 1;
            }
            finalArr.push(obj);
            ++order;
          });
        } else if (shareDataKey == "documents") {
          shareDataObj?.selectedData?.map((v, k) => {
            finalArr.push({ ...shareDataObj, ...v, key: shareDataKey, order });
            ++order;
          });
        } else if (shareDataKey == "letterOrders") {
          shareDataObj?.selectedData?.map((v, k) => {
            finalArr.push({ ...shareDataObj, ...v, key: shareDataKey, order });
            ++order;
          });
        } else if (shareDataKey == "encounter") {
          shareDataObj?.selectedData?.map((v, k) => {
            finalArr.push({ ...shareDataObj, ...v, key: shareDataKey, order });
            ++order;
          });
        } else if (shareDataKey == "referrals") {
          shareDataObj?.selectedData?.map((v, k) => {
            finalArr.push({ ...shareDataObj, ...v, key: shareDataKey, order });
            ++order;
          });
        } else if (shareDataKey == "uploads") {
          shareDataObj?.selectedData?.map((v, k) => {
            finalArr.push({ ...shareDataObj, ...v, key: shareDataKey, order });
            ++order;
          });
        } else {
          if (shareDataObj?.selectedData?.length > 0) {
            finalArr.push({ ...shareDataObj, key: shareDataObj?.slug, order });
            ++order;
          }
        }
      });
    } else {
      Object?.keys(shareDataArr)?.map((shareDataKey, index) => {
        let shareDataObj = shareDataArr[shareDataKey];
        if (shareDataKey == "clinicalRecord") {
          let selectedCR = shareDataObj?.data?.filter((v, k) => v?.checked);
          selectedCR?.map((v, k) => {
            let obj = { ...shareDataObj, ...v, key: shareDataKey, order };
            if (v?.slug == "patient_sheet") {
              obj.csv = shareDataArr?.csv && 1;
            }
            finalArr.push(obj);
            ++order;
          });
        }
        if (shareDataKey != "filter" && shareDataArr[shareDataKey]?.isChecked) {
          finalArr.push({ ...shareDataObj, key: shareDataObj?.slug, order });
          ++order;
        }
      });
    }
    setProcessShareDataArr([...finalArr]);
  }, [shareDataArr]);

  const closeHandler = () => {
    setOpenOrderRequestDialog(false);
  };

  const continueHandler = () => {
    const details = [];
    const pid = selectedChat?.pid;
    const practice = practice_id;
    const is_ccm = "0";
    const is_rpm = "0";

    Object.keys(processShareDataArr)?.forEach((key) => {
      const item = processShareDataArr[key];
      if (item?.key === "clinicalRecord") {
        const filteredData = item?.data?.filter(
          (dataItem) => dataItem?.checked
        );
        if (filteredData?.length > 0) {
          let rangeContent =
            item?.start_date && item?.end_date
              ? `${item?.slug}~${item?.start_date}#${item?.end_date}`
              : `${item?.slug}~${item?.days || "all"}`;

          let rangeValue =
            item?.start_date && item?.end_date
              ? `${moment(item?.start_date).format("MM/DD/YYYY")} to ${moment(
                  item?.end_date
                ).format("MM/DD/YYYY")}`
              : "";
          details.push({
            order: item?.order,
            title: item?.title,
            type: "clinical",
            content: rangeContent,
            rangeValue: rangeValue,
            ...(item?.csv && { csv: item?.csv }),
          });
        }
      } else if (item?.selectedData?.length > 0 && !isLocationTab) {
        const createDetail = (type, additionalProps = {}) => ({
          order: item?.order,
          title: item?.title,
          type: type,
          content: item?.selectedData
            ?.map((v) => v?.id || v?.response?.data)
            .join(","),
          ...additionalProps,
        });

        const dateFormatted = (date) => moment(date).format("MM/DD/YYYY");

        switch (item?.slug) {
          case "ccd":
            details.push(
              createDetail(item?.slug, {
                export_datetime: item?.selectedData
                  ?.map((v) => v?.response?.meta?.export_datetime)
                  .join(","),
                file_uuid: item?.selectedData
                  ?.map((v) => v?.response?.meta?.file_uuid)
                  .join(","),
                pid: item?.selectedData
                  ?.map((v) => v?.response?.meta?.pid)
                  .join(","),
                txt_file: item?.selectedData
                  ?.map((v) => v?.response?.meta?.txt_file)
                  .join(","),
              })
            );
            break;
          case "triage":
          case "screening":
            details.push(createDetail(item?.slug));
            break;
          case "documents":
            details.push(
              createDetail("attachments", {
                mime_type: item?.mime_type,
                content: item?.id,
              })
            );
            break;
          case "labResults":
            details.push(createDetail("lab")); // Updated type to "lab"
            break;
          case "radiologyResults":
            details.push(createDetail("radiology"));
            break;
          case "letterOrders":
            details.push(createDetail("letter", { content: item?.id }));
            break;
          case "encounter":
            details.push(
              createDetail("encounter", {
                content: item?.encounter,
                title: `${dateFormatted(item?.date)}`||"N/A",
                encounterData: { ...item, selectedData: undefined },
              })
            );
            break;
          case "billingData":
            details.push(
              createDetail("billing_data", {
                title: `Charges (DOS: ${item?.selectedData
                  ?.map((v) => dateFormatted(v.dos))
                  .join(",")})`,
                content: item?.selectedData
                  ?.map((v) => v?.billing_charge_id)
                  .join(","),
              })
            );
            break;
          case "referrals":
            details.push(
              createDetail("referral", {
                content: item?.id,
                details: [
                  {
                    title: `Referral ${dateFormatted(item?.referred_to_date)}`,
                    type: "referral",
                    mime_type: "application/pdf",
                    content: item?.id,
                  },
                ],
              })
            );
            break;
          case "appointments":
            details.push(
              createDetail("appointments", {
                title: `Appointments <br> ${item?.selectedData
                  ?.map(
                    (v) =>
                      `${dateFormatted(v?.formated_datetime)} on ${
                        v?.startTime_ampm
                      } - ${v?.endTime_ampm} (${v?.duration_formated})`
                  )
                  .join(" <br> ")}`,
                csv: 0,
              })
            );
            break;
          case "uploads":
            details.push(
              createDetail("file", {
                content: item?.attachment_id,
                mime_type: item?.mime_type,
              })
            );
            break;
        }
      } else if (isLocationTab && key != "filter" && item?.isChecked) {
        details?.push({
          order: item?.order,
          title: item?.title,
          type: item?.slug,
          content: "",
        });
      }
    });

    const finalData = {
      pid,
      practice,
      details,
      is_ccm,
      is_rpm,
    };
    if (isLocationTab) {
      finalData.practice_id = selectedChat?.location?.id;
      finalData.pid =
        shareDataArr?.all_patients?.all_patients == "1"
          ? ""
          : shareDataArr?.pid;
      finalData.start_date = shareDataArr?.start_date;
      finalData.end_date = shareDataArr?.end_date;
      finalData.document_type = shareDataArr?.document_type;
      finalData.all_patients = shareDataArr?.all_patients;
    }
    if (details[0]?.txt_file && !isLocationTab) {
      finalData.ccd_file = details[0]?.txt_file;
    }
    
    toast.success("Your Data is Processing");
    setOpenOrderRequestDialog(false);
    resetHandler();
    prepareData(finalData)
  };

  const renderData = (shareDataObj, index) => {
    const commonData = {
      ...shareDataObj,
      key: index,
    };

    switch (shareDataObj?.key) {
      case "clinicalRecord":
        return (
          <TableBody
            data={{
              ...commonData,
              title: shareDataObj?.csv
                ? `${shareDataObj?.title} (csv)`
                : shareDataObj?.title,
              type:
                shareDataObj?.start_date || shareDataObj?.end_date
                  ? `Clinical ( ${moment(shareDataObj?.start_date).format(
                      "MM/DD/YYYY"
                    )} to ${moment(shareDataObj?.end_date).format(
                      "MM/DD/YYYY"
                    )})`
                  : `Clinical (${
                      shareDataObj?.slug === "ccm_summary"
                        ? "Ccm_summaryall"
                        : "All"
                    })`,
            }}
          />
        );
      case "triage":
        return <TableBody data={{ ...commonData, type: "Triage" }} />;
      case "ccd":
        return (
          <TableBody data={{ ...commonData, title: "CCD", type: "Ccd" }} />
        );
      case "screening":
        return <TableBody data={{ ...commonData, type: "Screening" }} />;
      case "documents":
        return (
          <TableBody
            data={{
              ...commonData,
              title: shareDataObj?.title,
              type: "Documents",
            }}
          />
        );
      case "labResults":
        return <TableBody data={{ ...commonData, type: "Lab" }} />;
      case "radiologyResults":
        return (
          <TableBody data={{ ...commonData, type: "Radiology Results" }} />
        );
      case "letterOrders":
        return (
          <TableBody
            data={{
              ...commonData,
              title: shareDataObj?.template_name || "Letter/Order Result",
              type: "Letters / Orders",
            }}
          />
        );
      case "encounter":
        return (
          <TableBody
            data={{
              ...commonData,
              title: isLocationTab
                ? "Encounter"
                : `${moment(shareDataObj?.date).format("MM/DD/YYYY")} - ${
                    shareDataObj?.reason || "N/A"
                  }`,
              type: "Encounter",
            }}
          />
        );
      case "billingData":
        return (
          <TableBody
            data={{
              ...commonData,
              title: isLocationTab
                ? "Billing"
                : `Charges ( DOS: ${shareDataObj?.selectedData
                    ?.map((item) => moment(item.dos).format("MM/DD/YYYY"))
                    .join(",")} )`,
              type: "Billing",
            }}
          />
        );
      case "referrals":
        return (
          <TableBody
            data={{
              ...commonData,
              title: `Referral ${moment(shareDataObj?.referred_to_date).format(
                "MM/DD/YYYY"
              )}`,
              type: "Referrals",
            }}
          />
        );
      case "appointments":
        return (
          <TableBody
            data={{
              ...commonData,
              title: (
                <div>
                  Appointments{" "}
                  {shareDataObj?.selectedData?.map((item) => (
                    <div key={item.id}>
                      {`${moment(item.formated_datetime).format(
                        "MM/DD/YYYY"
                      )} on ${item.startTime_ampm} - ${item.endTime_ampm} (${
                        item?.duration_formated
                      })`}
                    </div>
                  ))}
                </div>
              ),
              type: "Appointments",
            }}
          />
        );
      case "uploads":
        return (
          <TableBody
            data={{
              ...commonData,
              title: (
                <div className="flex items-center gap-1 -ml-1.5">
                  <FcImageFile className="w-7 h-6" />
                  <div>{shareDataObj?.title}</div>
                </div>
              ),
              type: "File",
            }}
          />
        );
      default:
        return null;
    }
  };
  const removeHandler = (index) => {
    const updatedData = [...processShareDataArr];
    updatedData.splice(index, 1);
    setProcessShareDataArr(updatedData);
  };

  const TableBody = ({ data }) => {
    const previewHandler = () => {
      let params = "id=" + data?.id;
      params += "&token=" + authToken;
      params += "&tz=" + String(new Date().getTimezoneOffset());
      const url =
        process.env.REACT_APP_API_URL_V1 + "/documents/view.json?" + params;
      window.open(url, "_blank");
    };
    return (
      <tr
        draggable
        onDragStart={(e) => e.dataTransfer.setData("draggedIndex", data?.key)}
        className="odd:bg-white even:bg-gray-50"
      >
        <td className="px-6 py-4 align-top text-xs text-slate-600 whitespace-nowrap">
          # <strong>{data?.order}</strong>
        </td>
        <td className="px-6 py-4 align-top text-xs text-slate-600">
          {data?.title}{" "}
        </td>
        <td className="px-6 py-4 align-top text-xs text-slate-600">
          <strong>{data?.key + 1}</strong>
        </td>
        <td className="px-6 py-4 align-top text-xs text-slate-600">
          {data?.type}
        </td>
        <td className="px-6 py-4 align-top text-xs text-slate-600 justify-self-end pr-2">
          <div className="flex gap-4">
            {data?.slug === "documents" && !isLocationTab ? (
              <FaEye
                title="preview"
                className="text-sky-400 hover:text-sky-600 size-5 cursor-pointer"
                onClick={previewHandler}
              />
            ) : (
              <div className="size-5"></div>
            )}
            <IoClose
              title="remove"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                removeHandler(data?.key);
              }}
              className="text-red-600 size-5 font-black cursor-pointer"
            />
          </div>
        </td>
      </tr>
    );
  };

  const footerList = [
    {
      type: "cancel",
      action: () => {
        closeHandler();
      },
      title: "Cancel",
    },
    {
      type: "save",
      action: () => {
        continueHandler();
      },

      title: "Continue",
    },
  ];

  return (
    <>
      {openOrderRequestDialog && (
        <MainPageDialog
          title="Order Request Data"
          onCancelHandler={() => closeHandler()}
          footer={true}
          footerList={footerList}
          modalSize="md"
        >
          {false && <FullScreenLoader />}
          <table className="min-w-full divide-y divide-gray-200 mb-10">
            <thead className="bg-bgGreen">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-white tracking-wider w-[10%]">
                  #
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white tracking-wider w-[30%]">
                  Title
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white tracking-wider w-[10%]">
                  Order
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white tracking-wider w-[35%]">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white tracking-wider w-[15%]"></th>
              </tr>
            </thead>
            <tbody
              className="bg-white divide-y divide-gray-200 cursor-n-resize text-left"
              title="Drag to reorder"
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                const draggedIndex = e.dataTransfer.getData("draggedIndex");
                const targetIndex = e.target.closest("tr").rowIndex - 1;
                const updatedData = [...processShareDataArr];
                const [draggedItem] = updatedData.splice(draggedIndex, 1);
                if (updatedData[targetIndex]?.order !== draggedItem?.order) {
                  updatedData.splice(targetIndex, 0, draggedItem);
                  setProcessShareDataArr(updatedData);
                }
              }}
            >
              {processShareDataArr?.map((shareDataObj, index) => {
                return renderData(shareDataObj, index);
              })}
            </tbody>
          </table>
        </MainPageDialog>
      )}
    </>
  );
}

export default OrderRequestData;
